<template>
  <section class="warning full-width">

      <h2>Loading...</h2>



  </section>
</template>

<script>
export default {
    name: 'Warning'
}
</script>

<style scoped lang="scss">
    .warning {
        height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        h2 {
            color: white;
        }
    }
</style>